import _slicedToArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import wlcBtnNext from "./components/update/wlc-btn-next.vue";
import wlcConversationList from "./components/update/wlc-conversation-list.vue";
import wlcBtnNotice from "./components/update/wlc-btn-notice.vue";
import RecordLog from "./components/update/RecordLog.vue";
import MediumRecordLog from "./components/update/MediumRecordLog.vue";
import { appendUrlParam } from "@/utils/url";
import { mapKeys } from "@/utils/mapKeys";
import { debounce } from "lodash";
import util from "@/libs/util";
var perceptionCode = {
  PHiuUt: "诈骗",
  orTPeJ: "中介/二房东"
};
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  components: {
    wlcBtnNext: wlcBtnNext,
    wlcConversationList: wlcConversationList,
    wlcBtnNotice: wlcBtnNotice,
    RecordLog: RecordLog,
    MediumRecordLog: MediumRecordLog
  },
  name: "house-update",
  data: function data() {
    return {
      previewDialogVisible: false,
      imageRotateDialogVisible: false,
      imageRotateUrl: "",
      imageRotateKey: "",
      releaseCompleteState: false,
      // releaseCompleteHref: "",
      bedroom: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      bathroom: [1, 2, 3, 4, 5],
      address: "",
      landlordAuth: {
        house_auth_count: 0,
        user_auth_count: 0
      },
      userInfo: {},
      // 房源标签
      houseForm: {
        id: "",
        // 用户id
        name: "",
        // 昵称
        remark: "",
        // 备注
        occupation: "",
        // 职业
        avatar: "",
        // 头像
        personalDesc: "",
        // 个人说明
        introduce: "",
        // 个人说明
        tags: [],
        // 房源标签
        rentTypeId: "",
        // 租房类型（合租／整租）
        timeTypeId: "",
        // 租房时间类型（长租／短租）
        floor: "",
        // 楼层
        cityId: "",
        // 城市id
        districtId: "",
        // 区域id
        address: "",
        // 地址
        bedroom: "",
        // 卧室个数
        bathroom: "",
        // 洗手间个数
        area: "",
        // 面积
        subways: [],
        // 地铁线地铁线id
        rent: "",
        // 租金
        deposit: "",
        // 押金
        longitude: "",
        // 经度
        latitude: "",
        // 纬度
        desc: "",
        // 描述
        imgs: [],
        // 房屋图片
        devices: [],
        // 房屋设施
        areaUnit: "㎡",
        // 面积单位
        currencyUnit: "RMB",
        // 货币单位
        video: "",
        dailyRent: "",
        // 日租金
        houseCode: ""
      },
      // 获取房源配置信息
      houseConfig: {},
      facilitys: [],
      // 房源标签
      houseTag: [],
      // 房源标签
      houseNewVisible: false,
      houseNewValue: "",
      mapInstance: null,
      mapGeocoder: null,
      mapCityName: "",
      mapAreaName: "",
      ipInfo: {},
      ipLocation: "",
      ipCounty: "中国",
      imgsCensor: {},
      typeTags: [],
      typeTagsVal: [],
      newHouseImageUrl: "",
      stopShortcutEvent: false,
      risk: {
        rentUint: false,
        name: false,
        personalDescription: false,
        housePersonalDescription: false,
        houseDescription: false,
        positioning: false
      },
      btnNextVisible: false,
      loading: false,
      userTag: [],
      deviceRisk: {},
      pointMark: {},
      initialFeatured: false,
      //初始精选标签是否存在
      prompts: {},
      imgScore: new Map([]),
      analysisResult: [],
      houseRecord: [],
      redBookAccount: ""
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getHouseConfig(function () {
              _this.getHouseInfo();
            });
            // this.getLocationByUserId();
            _this.getUsersTagList();
            _this.getUserDeviceRisk();

            // 添加全局键盘事件监听
            document.addEventListener("keydown", _this.handleKeyDown);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    //this.mapInstance.removeEventListener("dragging", this.draggingMap);
    //this.mapInstance.removeEventListener("zoomend", this.zoomEndMap);
    // 清除地图上所有覆盖物
    if (this.mapInstance) {
      this.mapInstance.clearOverlays();
      // 销毁地图实例，释放内存
      this.mapInstance = null;
      this.pointMark = null;
    }

    // 移除全局键盘事件监听
    document.removeEventListener("keydown", this.handleKeyDown);
  },
  watch: {
    "$route.query.id": function $routeQueryId() {
      this.userTag = [];
      this.loading = true;
      this.redBookAccount = "";
      this.getHouseInfo();
      // this.getLocationByUserId();
      this.getUsersTagList();
      this.getUserDeviceRisk();
      this.btnNextVisible = false;
      this.releaseCompleteState = false;
      var containerBody = document.getElementsByClassName("d2-container-full__body")[0];
      containerBody.scrollTop = 0;
    },
    mapAreaName: function mapAreaName() {
      this.mapSearch();
    },
    "houseForm.address": {
      handler: function handler() {},
      // 深度观察
      deep: true
    },
    newHouseImageUrl: function newHouseImageUrl() {
      this.houseForm.imgs.push(this.newHouseImageUrl);
    },
    previewDialogVisible: function previewDialogVisible() {
      var _this2 = this;
      this.$nextTick(function () {
        if (_this2.previewDialogVisible) {
          document.addEventListener("keydown", _this2.keydownEventHandle);
        } else {
          document.removeEventListener("keydown", _this2.keydownEventHandle);
        }
      });
    }
  },
  computed: {
    getPerceptionCodeName: function getPerceptionCodeName() {
      return perceptionCode[this.deviceRisk.perception_code] ? perceptionCode[this.deviceRisk.perception_code] : "";
    },
    showQuarterRadar: function showQuarterRadar() {
      var _this$$route$query;
      //只展示季度相关
      return (_this$$route$query = this.$route.query) === null || _this$$route$query === void 0 ? void 0 : _this$$route$query.from.includes("quarter");
    }
  },
  methods: {
    thumbnailUrl: function thumbnailUrl(url) {
      return url ? appendUrlParam(url, "imageView2/0/w/400/h/300|imageMogr2/auto-orient") : "";
    },
    keydownEventHandle: function keydownEventHandle(event) {
      if (event.key === "ArrowLeft") {
        this.$refs.carousel.prev();
      }
      if (event.key === "ArrowRight") {
        this.$refs.carousel.next();
      }
    },
    handleKeyDown: function handleKeyDown(event) {
      // Command+P (Mac) 或 Ctrl+P (Windows) 触发通过操作
      if ((event.metaKey || event.ctrlKey) && (event.key === "p" || event.key === "P")) {
        event.preventDefault(); // 阻止默认行为（打印页面）
        if (this.loading) {
          this.$message.error("加载中... 违规操作");
          return;
        }
        if (this.houseForm.status == 1 && this.$refs.passBtn) {
          this.$refs.passBtn.auditHouse(4);
        }
      }

      // Command+Shift+Q (Mac) 或 Ctrl+Shift+Q (Windows) 触发季度操作
      if ((event.metaKey || event.ctrlKey) && (event.key === "b" || event.key === "B")) {
        event.preventDefault();
        if (this.loading) {
          this.$message.error("加载中... 违规操作");
          return;
        }
        if (this.houseForm.status == 1 && this.userInfo.user_type == 0 && this.$refs.quarterBtn) {
          this.$refs.quarterBtn.setUserType();
        }
      }

      // Command+A (Mac) 或 Ctrl+A (Windows) 触发认证操作
      if ((event.metaKey || event.ctrlKey) && (event.key === "a" || event.key === "A")) {
        event.preventDefault(); // 阻止默认行为（全选）
        if (this.loading) {
          this.$message.error("加载中... 违规操作");
          return;
        }
        if (this.houseForm.status == 1 && this.userInfo.user_type == 0 && this.$refs.authBtn) {
          this.$refs.authBtn.setHouseAuthStatus();
        }
      }

      // 空格键触发下一个操作（仅当btnNextVisible为true时）
      if (event.key === " " && this.btnNextVisible && this.$refs.btnNext) {
        if (this.stopShortcutEvent) return ' '; //备注信息空格禁用快捷操作
        event.preventDefault(); // 阻止默认行为（滚动页面）
        if (this.loading) {
          this.$message.error("加载中... 违规操作");
          return;
        }
        this.$refs.btnNext.nextHouse();
        this.loading = true;
      }
    },
    goDeviceList: function goDeviceList() {
      window.open("#/user/deviceId?phone=".concat(this.userInfo.phone));
    },
    auditComplete: function auditComplete() {
      this.releaseCompleteState = true;
      if (this.$route.query.from == "house_audit_edit" || this.$route.query.from == "quarter_audit_edit" || this.$route.query.from == "brand_audit_edit") {
        this.btnNextVisible = true;
      }
    },
    previewImage: function previewImage(index) {
      var _this3 = this;
      this.previewDialogVisible = true;
      this.$nextTick(function () {
        setTimeout(function () {
          _this3.$refs.carousel.setActiveItem(index);
        });
      });
    },
    closeRotateDialog: function closeRotateDialog() {
      this.imageRotateDialogVisible = false;
    },
    saveRotateImgUrl: function saveRotateImgUrl(url) {
      this.houseForm.imgs.splice(this.imageRotateKey, 1, url);
    },
    selectRotateImg: function selectRotateImg(key) {
      this.imageRotateKey = key || 0;
      this.imageRotateUrl = this.houseForm.imgs[this.imageRotateKey];
      this.imageRotateDialogVisible = true;
    },
    getTypeTagList: function getTypeTagList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this4.typeTagsVal = [];
              _context2.n = 1;
              return _this4.$api.getHouseTypeTagList({
                id: _this4.$route.query.id
              });
            case 1:
              res = _context2.v;
              _this4.typeTags = res.data;
              _this4.typeTags.forEach(function (item) {
                if (_this4.houseForm.typeTags.indexOf(item.ch) > -1) {
                  _this4.typeTagsVal.push(item.id);
                }
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    updateHouseTypeTagList: function updateHouseTypeTagList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this5.$api.updateHouseTypeTagList({
                id: _this5.$route.query.id,
                tagIds: _this5.typeTagsVal
              });
            case 1:
              //如果存在精选并且初始不存在精选 可上报精选修改日志
              if (_this5.typeTagsVal.includes("2") && !_this5.initialFeatured) {
                setTimeout(function () {
                  _this5.$operationLog.push({
                    operationType: "text",
                    code: "typetags",
                    userId: _this5.$route.query.userId,
                    detailBatchNo: "\u7CBE\u9009"
                  });
                }, 400);
                _this5.initialFeatured = true;
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    onCopy: function onCopy() {
      this.$message.success("复制成功");
    },
    onError: function onError() {
      this.$message.error("复制失败");
    },
    getLocationByUserId: function getLocationByUserId() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this6.$api.getLocationByUserId({
                userId: _this6.$route.query.userId
              });
            case 1:
              res = _context4.v;
              _this6.ipLocation = res.data.location;
              _this6.ipCounty = res.data.country;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    //选择建议值后赋值并设置地图中心点位置
    selectAddress: function selectAddress(e) {
      this.houseForm.longitude = (e === null || e === void 0 ? void 0 : e.lng) || this.houseForm.longitude;
      this.houseForm.latitude = (e === null || e === void 0 ? void 0 : e.lat) || this.houseForm.latitude;
      this.setCenterMark();
    },
    //flag 为true 不缩放层级
    setCenterMark: function setCenterMark(flag) {
      if (this.houseForm.longitude) {
        var _this$houseForm = this.houseForm,
          longitude = _this$houseForm.longitude,
          latitude = _this$houseForm.latitude;
        var point = new BMap.Point(longitude, latitude);
        this.pointMark.setPosition(point);
        flag ? this.mapInstance.setCenter(point) : this.mapInstance.centerAndZoom(point, 18);
      }
    },
    mapSearch: debounce(function (str, cb) {
      if (!(str !== null && str !== void 0 && str.trim())) return cb === null || cb === void 0 ? void 0 : cb([]);
      var self = this;
      var options = {
        onSearchComplete: function onSearchComplete(results) {
          // 判断状态是否正确
          if (local.getStatus() == BMAP_STATUS_SUCCESS) {
            var arr = [];
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              var info = results.getPoi(i);
              var city = info.city,
                address = info.address,
                title = info.title,
                uid = info.uid,
                _info$point = info.point,
                lat = _info$point.lat,
                lng = _info$point.lng;
              arr.push({
                city: city,
                title: title,
                address: address,
                id: uid,
                lat: lat,
                lng: lng,
                value: title
              });
            }
            cb === null || cb === void 0 || cb(arr);
          }
        }
      };
      var local = new BMap.LocalSearch(self.mapInstance, options);
      local.search(str);
    }, 500),
    draggingMap: function draggingMap() {
      var newCenter = this.mapInstance.getCenter();
      this.houseForm.longitude = newCenter.lng;
      this.houseForm.latitude = newCenter.lat;
      this.setCenterMark(true);
    },
    zoomEndMap: function zoomEndMap() {
      var _this$houseForm2 = this.houseForm,
        longitude = _this$houseForm2.longitude,
        latitude = _this$houseForm2.latitude;
      var centerPoint = new BMap.Point(longitude, latitude);
      this.mapInstance.setCenter(centerPoint);
    },
    mapInit: function mapInit() {
      var self = this;
      self.mapInstance = new BMap.Map("map-container");
      var centerCity = "北京";
      // 初始化地图，设置中心点坐标和地图级别
      self.mapInstance.centerAndZoom(this.mapCityName || centerCity, 11);
      // 开启鼠标滚轮缩放
      self.mapInstance.enableScrollWheelZoom(true);
      var control = new BMap.ScaleControl({
        anchor: BMAP_ANCHOR_TOP_LEFT
      }); // 左上角，添加比例尺
      var navigation = new BMap.NavigationControl({
        anchor: BMAP_ANCHOR_TOP_LEFT,
        enableGeolocation: true
      }); //左上角，添加默认缩放平移控件
      self.mapInstance.addControl(control);
      self.mapInstance.addControl(navigation);

      //self.mapInstance.addEventListener("dragging", this.draggingMap);
      //self.mapInstance.addEventListener("zoomend", this.zoomEndMap);

      //存在经纬度时设置中心点为源点和显示地点图标
      if (self.houseForm.longitude) {
        var _self$houseForm = self.houseForm,
          longitude = _self$houseForm.longitude,
          latitude = _self$houseForm.latitude;
        var point = new BMap.Point(longitude, latitude);
        this.pointMark = new BMap.Marker(point);
        self.mapInstance.centerAndZoom(point, 18);
        self.mapInstance.addOverlay(this.pointMark);
      }
    },
    getBlackIP: function getBlackIP() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this7.$api.getBlackIpByUser({
                user_id_array: _this7.$route.query.userId
              });
            case 1:
              res = _context5.v;
              if (res.data[_this7.$route.query.userId]) {
                _this7.ipInfo = res.data[_this7.$route.query.userId];
              } else {
                _this7.ipInfo = {};
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getUserDeviceRisk: function getUserDeviceRisk() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var userId, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              userId = _this8.$route.query.userId;
              _context6.n = 1;
              return _this8.$api.getUserDeviceRisk({
                user_id: userId
              });
            case 1:
              res = _context6.v;
              _this8.deviceRisk = res.data;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getUsersTagList: function getUsersTagList() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var userId, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              userId = _this9.$route.query.userId;
              _context7.n = 1;
              return _this9.$api.getUsersTagList({
                top: 5,
                user_id: userId
              });
            case 1:
              res = _context7.v;
              if (res.data[userId]) {
                _this9.userTag = res.data[userId];
              }
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    getHouseInfo: function getHouseInfo() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _this0$houseForm$type;
        var res, imgs, subways;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _this0.getLogList();
              _context9.n = 1;
              return _this0.$api.getHouseInfo({
                id: _this0.$route.query.id
              });
            case 1:
              res = _context9.v;
              if (!(res.data.id != _this0.$route.query.id)) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2);
            case 2:
              _this0.getBlackIP();
              _this0.mapCityName = res.data.city;
              _this0.mapAreaName = res.data.district;
              _this0.userInfo = res.data.userInfo;
              _this0.risk = res.data.risk;
              _this0.houseForm.city = res.data.city;
              _this0.houseForm.quarterHouseCity = res.data.quarterHouseCity;
              _this0.houseForm.id = res.data.userInfo.id;
              _this0.houseForm.appInfo = res.data.userInfo.appInfo;
              _this0.houseForm.scene = res.data.userInfo.scene;
              _this0.houseForm.cityMasterInfo = res.data.cityMasterInfo;
              _this0.houseForm.ip = res.data.ip;
              _this0.houseForm.name = res.data.userInfo.name;
              _this0.houseForm.occupation = res.data.userInfo.occupation;
              _this0.houseForm.phone = res.data.userInfo.phone;
              _this0.houseForm.remark = res.data.userInfo.remark;
              _this0.houseForm.avatar = res.data.userInfo.avatar;
              _this0.houseForm.loginType = res.data.userInfo.loginType;
              _this0.houseForm.unionid = res.data.userInfo.unionid;
              _this0.houseForm.appleUnionid = res.data.userInfo.appleUnionid;
              _this0.houseForm.logoutCount = res.data.userInfo.logoutCount;
              _this0.cityChange(res.data.cityId);
              _this0.houseForm.dailyRent = res.data.dailyRent;
              _this0.houseForm.rentTypeId = res.data.rentTypeId;
              _this0.houseForm.timeTypeId = res.data.timeTypeId;
              _this0.houseForm.floor = res.data.floor;
              _this0.houseForm.cityId = res.data.cityId;
              _this0.houseForm.districtId = res.data.districtId;
              _this0.houseForm.address = res.data.address;
              _this0.address = res.data.address;
              _this0.houseForm.bedroom = res.data.bedroom;
              _this0.houseForm.bathroom = res.data.bathroom;
              _this0.houseForm.area = res.data.area;
              _this0.houseForm.subways = res.data.subways;
              _this0.houseForm.rent = res.data.rent;
              _this0.houseForm.deposit = res.data.deposit;
              _this0.houseForm.longitude = res.data.longitude;
              _this0.houseForm.latitude = res.data.latitude;
              _this0.houseForm.desc = res.data.desc;
              _this0.houseForm.currencyUnit = res.data.currencyUnit;
              _this0.houseForm.areaUnit = res.data.areaUnit;
              _this0.houseForm.video = res.data.video;
              _this0.houseForm.status = res.data.status;
              _this0.houseForm.houseCode = res.data.houseCode;
              _this0.houseForm.houseId = res.data.id;
              _this0.landlordAuth = res.data.landlordAuth;
              imgs = [];
              res.data.imgs.forEach(function (item) {
                imgs.push(item.url);
                _this0.imgsCensor[item.url] = {
                  censor_label: item.censor_label,
                  censor_status: item.censor_status
                };
              });
              _this0.houseForm.imgs = imgs;
              _this0.houseForm.blackIp = res.data.blackIp;
              _this0.houseForm.blackIpRemark = res.data.blackIpRemark;
              _this0.houseForm.personalDesc = res.data.personalDesc || res.data.userInfo.introduce;
              _this0.houseForm.introduce = res.data.userInfo.introduce;
              _this0.houseTag = res.data.tags;
              _this0.facilitys = res.data.devices;

              //获取用户标签信息
              _this0.getUserListByIds([_this0.userInfo], "id", '', "newUser");

              // 地铁
              subways = [];
              res.data.subways.forEach(function (item) {
                subways.push(item.id);
              });
              _this0.houseConfig.subway.forEach(function (item, index) {
                if (subways.indexOf(item.id) !== -1) {
                  item.isSelected = true;
                } else {
                  item.isSelected = false;
                }
              });
              _this0.mapInit();
              _this0.houseForm.subwayLine = res.data.subwayLine;
              _this0.houseForm.subwayStation = res.data.subwayStation;
              _this0.houseForm.typeTags = res.data.typeTags;
              _this0.getTypeTagList();
              _this0.loading = false;
              if (!_this0.risk.quarterHouseCityMatch) {
                _this0.$confirm("\u8BE5\u5B63\u5EA6\u8D26\u53F7\u5F00\u901A\u57CE\u5E02\u4E3A".concat(_this0.houseForm.quarterHouseCity || "空", "\uFF0C\u5F53\u524D\u623F\u6E90\u5730\u5740\u4F4D\u4E8E").concat(_this0.houseForm.city), "注意", {
                  confirmButtonText: "知道了",
                  showCancelButton: false,
                  type: "warning"
                }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
                  return _regenerator().w(function (_context8) {
                    while (1) switch (_context8.n) {
                      case 0:
                        return _context8.a(2);
                    }
                  }, _callee8);
                }))).catch(function () {});
              }
              _this0.initialFeatured = false;
              //如果初始存在精选标签则 保存时不触发日志上报
              if ((_this0$houseForm$type = _this0.houseForm.typeTags) !== null && _this0$houseForm$type !== void 0 && _this0$houseForm$type.includes("精选")) {
                _this0.initialFeatured = true;
              }
              _context9.n = 3;
              return _this0.getInfoByAI();
            case 3:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    //获取 ai 分析
    getInfoByAI: function getInfoByAI() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var res, _res$data, house_audit_text_result, house_image_result, landlord_chat_record_result;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return _this1.$api.queryInfoByAI(_this1.houseForm.houseId);
            case 1:
              res = _context0.v;
              _res$data = res.data, house_audit_text_result = _res$data.house_audit_text_result, house_image_result = _res$data.house_image_result, landlord_chat_record_result = _res$data.landlord_chat_record_result; // this.setTextContent(house_audit_text_result);
              _this1.getReadBookId(house_image_result);
              // this.setImgScore(house_image_result);
              // this.setChatData(
              //     landlord_chat_record_result,
              //     house_audit_text_result?.result
              // );
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    getReadBookId: function getReadBookId(arr) {
      var ids = [];
      arr === null || arr === void 0 || arr.forEach(function (item) {
        var result = item.result;
        Object.entries(result).map(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];
          if (key === "red_book_account" && value) {
            ids.push(value);
          }
        });
      });

      // 用对象统计次数（假设 id 是字符串/数字，无类型冲突）
      var countMap = {};
      var maxCount = 0; // 最大出现次数
      var mostFrequentId; // 出现次数最多的 id

      for (var _i = 0, _ids = ids; _i < _ids.length; _i++) {
        var id = _ids[_i];
        countMap[id] = (countMap[id] || 0) + 1;
        if (countMap[id] >= maxCount) {
          maxCount = countMap[id];
          mostFrequentId = id;
        }
      }
      this.redBookAccount = mostFrequentId || "";
    },
    //设置文本信息
    setTextContent: function setTextContent(data) {
      var result = (data === null || data === void 0 ? void 0 : data.result) || {};
      var keyMap = {
        house_personal_desc: "personalDesc",
        house_desc: "desc"
      };
      result = mapKeys(result, keyMap);
      if (result) {
        for (var i in result) {
          var _data = result[i];
          var contains_contact = _data.contains_contact,
            cleaned_text = _data.cleaned_text;
          if (contains_contact) {
            this.$set(this.prompts, i, this.houseForm[i]);
            this.houseForm[i] = cleaned_text;
          }
        }
      }
    },
    //设置图文解析
    setImgScore: function setImgScore(arr) {
      var _this10 = this;
      var labelMap = {
        residence_score: "居住痕迹",
        is_flipped: "是否翻转",
        professional_score: "专业评分",
        apartment_style_score: "公寓风格",
        is_property_image: "房源相关",
        image_quality_score: "图片质量",
        has_contact_info: "联系信息",
        red_book_account: "小红书"
      };
      var tipKeys = ["is_flipped", "has_contact_info"];
      arr === null || arr === void 0 || arr.forEach(function (item) {
        var result = item.result;
        var arr = [];
        arr = Object.entries(result).map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            value = _ref5[1];
          //小红书信息
          if (key === "red_book_account" && value) {
            _this10.redBookAccount = value;
          }
          return {
            key: key,
            value: value,
            label: labelMap[key] || key,
            isRed: key === "is_property_image" && value === 0 || value && tipKeys.includes(key)
          };
        });
        _this10.imgScore.set(_this10.sliceImgURl(item.img_url), arr);
      });
    },
    //设置聊天解析
    setChatData: function setChatData(arr) {
      var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var labelMap = {
        is_agent_or_proxy: "是中介/代理/委托等",
        is_direct_landlord: "自称房东直租",
        avoid_platform_communication: "刻意回避平台交流",
        is_real_landlord: "为真实房东",
        is_sublet_apartment: "租客转租",
        is_shared_apartment: "租客合租找室友",
        is_agent: "是代理人",
        is_shared_rental: "是合租",
        is_sublet: "是转租"
      };
      var is_agent = result.is_agent,
        is_shared_rental = result.is_shared_rental,
        is_sublet = result.is_sublet;
      var obj = {
        is_agent: is_agent,
        is_shared_rental: is_shared_rental,
        is_sublet: is_sublet
      };
      var trueKeys = Object.keys(obj).filter(function (key) {
        return obj[key] === true;
      }).map(function (key) {
        return {
          key: key,
          label: labelMap[key],
          list: ""
        };
      });
      var keyMap = [];
      arr.forEach(function (item) {
        for (var i in item.result) {
          if (item.result[i]) {
            keyMap.push({
              label: labelMap[i],
              key: i,
              value: {
                tenant_id: item.tenant_id,
                house_id: item.house_id,
                token: item.token
              }
            });
          }
        }
      });
      keyMap = this.mergeByKey(keyMap).concat(trueKeys);
      this.analysisResult = keyMap;
    },
    mergeByKey: function mergeByKey(data) {
      var mergedMap = new Map();
      data.forEach(function (item) {
        var key = item.key,
          label = item.label,
          value = item.value;
        if (!mergedMap.has(key)) {
          mergedMap.set(key, {
            key: key,
            label: label,
            list: [value] // 初始化包含当前 value 的数组
          });
        } else {
          var group = mergedMap.get(key);
          var isDuplicate = group.list.some(function (obj) {
            return obj.tenant_id === value.tenant_id;
          });
          if (!isDuplicate) {
            group.list.push(value);
          }
        }
      });
      return Array.from(mergedMap.values());
    },
    toChatInfo: function toChatInfo(id) {
      window.open("#/im/chat/record/?userId=".concat(this.$route.query.userId, "&otherId=").concat(id));
    },
    sliceImgURl: function sliceImgURl(str) {
      return (str === null || str === void 0 ? void 0 : str.split("?")[0]) || "";
    },
    // 创建房源标签
    addHouseTag: function addHouseTag() {
      var val = this.houseNewValue;
      if (val) {
        this.houseTag.push({
          name: val,
          isSelected: 1,
          isUserAdd: 1
        });
      }
      this.houseNewVisible = false;
      this.houseNewValue = "";
    },
    // 删除房源标签
    removeHouseTag: function removeHouseTag(index) {
      this.houseTag.splice(index, 1);
    },
    // 显示新建语言标签输入框
    showHouseInput: function showHouseInput() {
      this.houseNewVisible = true;
      this.$nextTick(function () {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 选择标签
    selectHouseTag: function selectHouseTag(e) {
      if (e.target.tagName === "SPAN") {
        var index = e.target.dataset.index;
        if (index) {
          this.houseTag[index].isSelected = !this.houseTag[index].isSelected;
        }
      }
    },
    // 获取房源配置信息
    getHouseConfig: function getHouseConfig(cb) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var res;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _context1.n = 1;
              return _this11.$api.getHouseFilterType();
            case 1:
              res = _context1.v;
              cb && cb();
              _this11.houseConfig = res.data;
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    districtChange: function districtChange(val) {
      var _this12 = this;
      this.houseConfig.area.forEach(function (item) {
        if (item.id === val) {
          _this12.mapAreaName = item.name;
        }
      });
    },
    getLogList: function getLogList() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var res;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return _this13.$api.getHouseRecord(_this13.$route.query.id);
            case 1:
              res = _context10.v;
              _this13.houseRecord = res.data || [];
            case 2:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    // 选择城市
    cityChange: function cityChange(val) {
      var _this14 = this;
      this.houseForm.districtId = "";
      this.houseConfig.cityList.forEach(function (item) {
        if (item.id === val) {
          // this.mapGeocoder && this.mapGeocoder.setCity(item.name);
          _this14.mapInstance && _this14.mapInstance.centerAndZoom(item.name, 12);
          _this14.mapCityName = item.name;
          _this14.houseConfig.area = item.item;
          var subway = JSON.parse(JSON.stringify(item.subway));
          subway.forEach(function (item1) {
            item1.isSelected = false;
          });
          _this14.$set(_this14.houseConfig, "subway", subway);
        }
      });
    },
    // 删除房源图片
    removeImgae: function removeImgae(index) {
      if (this.houseForm.imgs.length == 3) {
        this.$message.error("最少保留3张图片");
        return;
      }
      this.houseForm.imgs.splice(index, 1);
    },
    // 选择房源设施
    chooseFacility: function chooseFacility(index) {
      this.facilitys[index].isSelected = !this.facilitys[index].isSelected;
    },
    //跳转小红书
    toRedBook: function toRedBook() {
      this.redBookAccount && window.open("https://www.xiaohongshu.com/search_result?keyword=".concat(this.redBookAccount, "&source=web_explore_feed"));
    },
    toUserPage: function toUserPage(phone) {
      this.$router.push({
        path: "/user/list",
        query: {
          phone: phone
        }
      });
    },
    // 发布房源
    release: function release(type) {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var houseForm;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              // 房源信息数据
              houseForm = JSON.parse(JSON.stringify(_this15.houseForm)); // 房源详情信息验证
              _this15.houseTag.forEach(function (item) {
                if (item.isSelected) {
                  houseForm.tags.push(item.id ? item.id : item.name);
                }
              });
              if (houseForm.avatar) {
                _context11.n = 1;
                break;
              }
              _this15.$message.error("请上传头像");
              return _context11.a(2, false);
            case 1:
              if (!(houseForm.tags.length === 0)) {
                _context11.n = 2;
                break;
              }
              _this15.$message.error("请选择房源标签");
              return _context11.a(2, false);
            case 2:
              if (!(!houseForm.rentTypeId || !houseForm.timeTypeId)) {
                _context11.n = 3;
                break;
              }
              _this15.$message.error("请选择房源类型");
              return _context11.a(2, false);
            case 3:
              if (houseForm.floor) {
                _context11.n = 4;
                break;
              }
              _this15.$message.error("请输入楼层信息");
              return _context11.a(2, false);
            case 4:
              if (houseForm.bedroom) {
                _context11.n = 5;
                break;
              }
              _this15.$message.error("请输入卧室");
              return _context11.a(2, false);
            case 5:
              if (houseForm.area) {
                _context11.n = 6;
                break;
              }
              _this15.$message.error("请输入面积");
              return _context11.a(2, false);
            case 6:
              if (houseForm.rent) {
                _context11.n = 7;
                break;
              }
              _this15.$message.error("请输入租金");
              return _context11.a(2, false);
            case 7:
              if (houseForm.deposit) {
                _context11.n = 8;
                break;
              }
              _this15.$message.error("请输入押金");
              return _context11.a(2, false);
            case 8:
              if (!(!houseForm.cityId || !houseForm.districtId)) {
                _context11.n = 9;
                break;
              }
              _this15.$message.error("请选择地址");
              return _context11.a(2, false);
            case 9:
              if (houseForm.address) {
                _context11.n = 10;
                break;
              }
              _this15.$message.error("请输入详细地址");
              return _context11.a(2, false);
            case 10:
              if (!(!houseForm.longitude || !houseForm.latitude)) {
                _context11.n = 11;
                break;
              }
              _this15.$message.error("请拖动地图选择精确位置");
              return _context11.a(2, false);
            case 11:
              // 地铁
              houseForm.subways = [];
              _this15.houseConfig.subway.forEach(function (item) {
                if (item.isSelected) {
                  houseForm.subways.push(item.id);
                }
              });

              // 描述及照片信息验证
              if (houseForm.desc) {
                _context11.n = 12;
                break;
              }
              _this15.$message.error("请输入房源描述");
              return _context11.a(2, false);
            case 12:
              if (!(houseForm.imgs.length < 3 || houseForm.imgs.length > 20)) {
                _context11.n = 13;
                break;
              }
              _this15.$message.error("请上传房源图片，最多20张，最少3张");
              return _context11.a(2, false);
            case 13:
              // 房间设施信息验证
              _this15.facilitys.forEach(function (item) {
                if (item.isSelected) {
                  houseForm.devices.push(item.id);
                }
              });
              if (!(houseForm.devices.length === 0)) {
                _context11.n = 14;
                break;
              }
              _this15.$message.error("请选择房源设施");
              return _context11.a(2, false);
            case 14:
              houseForm.houseId = _this15.$route.query.id;
              _context11.n = 15;
              return _this15.updateHouseTypeTagList();
            case 15:
              _context11.n = 16;
              return _this15.$api.updateHouse(houseForm);
            case 16:
              if (type != "audit") {
                _this15.$message.success("成功");
              }
              _this15.releaseCompleteState = true;
              if (type != "pass" && type != "set-user-type" && type != "set-house-type") {
                // 操作上报
                _this15.$operationLog.push({
                  operationType: "house",
                  code: "save",
                  houseId: _this15.$route.query.id,
                  userId: _this15.$route.query.userId
                });
              }
            case 17:
              return _context11.a(2);
          }
        }, _callee11);
      }))();
    }
  }
};